import Control from "../../../../../common/Controls/Control";
import RCPROPrestationsInternationales from "./RCPROPrestationsInternationales";
import useRCPROQuestion from "./useRCPROQuestion";

const RCPROHabillement = ({ company }) => {
  const { updateRcproData, onBlur, errors, inputsConfig, formState } =
    useRCPROQuestion({ company });

  const activityKey = "habillement";

  return (
    <div>
      <Control
        label={
          <>
            Faites-vous <strong>principalement</strong> de la fabrication ou de
            la revente ?
          </>
        }
        type="btnList"
        name="habillementProduitsFabriquesOuRevendus"
        value={company.RCPRO.habillementProduitsFabriquesOuRevendus}
        change={updateRcproData}
        error={errors}
        labelClassname="w-100"
        inputGroupStyle={{ width: "100%" }}
        btnInline
        datas={inputsConfig.habillementProduitsFabriquesOuRevendus.datas}
        dataIndex="id"
        dataLabel="name"
        onBlur={onBlur}
        required
      />
      {company.RCPRO.habillementProduitsFabriquesOuRevendus == 1 && (
        <Control
          label={inputsConfig.habillementTracabiliteMatieresPremieres.label}
          type="btnList"
          name="habillementTracabiliteMatieresPremieres"
          value={company.RCPRO.habillementTracabiliteMatieresPremieres}
          change={updateRcproData}
          error={errors}
          labelClassname="w-100"
          inputGroupStyle={{ width: "100%" }}
          btnInline
          datas={inputsConfig.habillementTracabiliteMatieresPremieres.datas}
          dataIndex="id"
          dataLabel="name"
          onBlur={onBlur}
          required
        />
      )}
      <RCPROPrestationsInternationales
        company={company}
        activityKey={activityKey}
      />
    </div>
  );
};

export default RCPROHabillement;
